import * as yup from "yup";

export const CP_KEY = {
    PGM_TYPE:'programType',
   }

export const initialValues  = {
    [CP_KEY.PGM_TYPE]: "",
} 

export const validationSchema = yup.object().shape({
    [CP_KEY.PGM_TYPE]: yup.string().required('Required'),   
});